module.exports = __webpack_public_path__ + "static/media/skype.8a6a6783.svg";